import { factorySetStateAction } from '../factory'
// Defined Device Constants to bind SAGA functions with Redux Dispatcher
const actions = {
  SET_STATE: 'billingEligibility/SET_STATE',
  GET_ELIGIBILITY_LOGS_LIST: 'billingEligibility/GET_ELIGIBILITY_LOGS_LIST',
  GET_VALUES_FOR_DROPDOWN: 'billingEligibility/GET_VALUES_FOR_DROPDOWN',
  GET_ELIGIBILITY_REPORT_LIST: 'billingEligibility/GET_ELIGIBILITY_REPORT_LIST',
}

export const billingEligibilitySetState = factorySetStateAction(actions.SET_STATE)

export default actions
